import { LANGUAGES, LANG_LABELS, LANG_NATIVE_NAMES } from './languages.js'
import './LangSwitch.css'

/**
 * `pending` marks a switch that has been asked for but not finished — the
 * new language is a server round trip away. `value` is expected to move
 * optimistically, so the group already shows the chosen language while
 * `aria-busy` and the dimmed state say it has not arrived yet. Clicks are
 * refused meanwhile: a second one during the round trip used to start a
 * second switch.
 */
export function LangSwitch({
  value = 'uz',
  onChange,
  label = 'Language',
  style,
  languages = LANGUAGES,
  pending = false,
}) {
  return (
    <div
      className={`u-lang${pending ? ' u-lang--pending' : ''}`}
      role="group"
      aria-label={label}
      aria-busy={pending || undefined}
      style={style}
    >
      {languages.map((l) => (
        <button
          key={l}
          type="button"
          lang={l}
          className={l === value ? 'u-lang--on' : ''}
          aria-pressed={l === value}
          disabled={pending && l !== value}
          onClick={() => onChange && onChange(l)}
        >
          <span aria-hidden="true">{LANG_LABELS[l]}</span>
          <span className="u-sr-only">{LANG_NATIVE_NAMES[l]}</span>
        </button>
      ))}
    </div>
  )
}

export default LangSwitch
